import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ChangeManagerMutationVariables = Types.Exact<{
  adsID: Types.Scalars['ID'];
  managerID: Types.Scalars['ID'];
}>;


export type ChangeManagerMutation = { __typename?: 'Mutation', changeAdManager?: string | null };


export const ChangeManagerDocument = gql`
    mutation changeManager($adsID: ID!, $managerID: ID!) {
  changeAdManager(adsID: $adsID, managerID: $managerID)
}
    `;
export type ChangeManagerMutationFn = Apollo.MutationFunction<ChangeManagerMutation, ChangeManagerMutationVariables>;

/**
 * __useChangeManagerMutation__
 *
 * To run a mutation, you first call `useChangeManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeManagerMutation, { data, loading, error }] = useChangeManagerMutation({
 *   variables: {
 *      adsID: // value for 'adsID'
 *      managerID: // value for 'managerID'
 *   },
 * });
 */
export function useChangeManagerMutation(baseOptions?: Apollo.MutationHookOptions<ChangeManagerMutation, ChangeManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeManagerMutation, ChangeManagerMutationVariables>(ChangeManagerDocument, options);
      }
export type ChangeManagerMutationHookResult = ReturnType<typeof useChangeManagerMutation>;
export type ChangeManagerMutationResult = Apollo.MutationResult<ChangeManagerMutation>;
export type ChangeManagerMutationOptions = Apollo.BaseMutationOptions<ChangeManagerMutation, ChangeManagerMutationVariables>;